import {Slide} from "@mui/material";
import Modal from "@mui/material/Modal";
import {useEffect, useRef, useState} from "react";
import SystemModalClosingVoid from "../../components/others/SystemModalClosingVoid";
import GameDetailedScreenHeader from "../../components/others/games/GameDetailedScreenHeader";
import DetailedGameBottomBar from "../../components/bars/games/DetailedGameBottomBar";
import DetailedGameScreenContent from "../../components/others/games/DetailedGameScreenContent";
import {isNullOrUndefined} from "../../services/Validator";

export default function GameDetailedScreen({ open,
                                             handleClose,
                                             game }) {
    // Used in GamesItem to display game levels list before
    // game selection

    // PROPERTIES
    const [selectedLevel, setSelectedLevel] = useState(game.levels[0]);
    const modalRef = useRef();

    // HOOKS
    // ---- At rendering
    useEffect(() => {
        if (open) {
            // Re-initialise le niveau sélectionné à l'ouverture
            setSelectedLevel(game.levels[0] ?? null);
        } else {
            // Nettoyage à la fermeture
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
            setSelectedLevel(null);
        }
    }, [open, game]);

    // BUILD
    return (
        <Modal open={open}
               onClose={handleClose}
               disableEnforceFocus>
            <Slide direction="left" in={open} mountOnEnter unmountOnExit>
                <div ref={modalRef}
                     className="overflow-auto w-full h-[100svh] flex outline-none">
                    <SystemModalClosingVoid handleClose={handleClose} />
                    <div className="bg-backgroundLight3 w-[416px] min-w-[416px] h-full flex flex-col justify-between overflow-hidden">
                        <GameDetailedScreenHeader game={game}
                                                  handleClose={handleClose} />
                        <DetailedGameScreenContent gameLevels={game.levels}
                                                   selectedLevel={selectedLevel}
                                                   setSelectedLevel={setSelectedLevel} />
                        <DetailedGameBottomBar isDisabled={isNullOrUndefined(selectedLevel)}
                                               route={selectedLevel?.route} />
                    </div>
                </div>
            </Slide>
        </Modal>
    );
}